import { type ReactNode } from 'react';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface MetricCardProps {
  icon: ReactNode;
  title: string;
  metric: string | number | undefined;
}

const MetricCard = ({ icon, title, metric }: MetricCardProps) => (
  <Card className='@container/card'>
    <CardHeader className='relative'>
      <CardDescription className='flex items-center gap-2'>
        <span className='text-primary'>{icon}</span>
        <span>{title}</span>
      </CardDescription>
      <CardTitle className='@[250px]/card:text-3xl text-2xl font-semibold tabular-nums'>
        {metric ?? '-'}
      </CardTitle>
    </CardHeader>
  </Card>
);

export default MetricCard;
